// Criar clube é só para Mentor (decisão do Wesley, 14/10/2026 — o app é
// grátis). Quem não é Mentor e toca em "Criar" cai aqui: um aviso simples, sem
// paywall nem oferta de assinatura. Entrar e participar de clubes segue livre.
// O servidor decide de verdade (403 mentor_required em POST /api/clubs).
import React from 'react';

export const SoMentorScreen: React.FC<{
  term?: string;
  onBack: () => void;
  onExplore: () => void;
}> = ({ term = 'clube', onBack, onExplore }) => (
  <div data-tela="so-mentor" style={{
    minHeight: '100%', display: 'flex', flexDirection: 'column',
    padding: 'calc(env(safe-area-inset-top, 0px) + 18px) 22px 32px',
    background: 'var(--paper)', color: 'var(--ink)',
  }}>
    <button onClick={onBack} aria-label="Voltar" style={{
      alignSelf: 'flex-start', background: 'none', border: 'none', padding: '6px 0',
      color: 'var(--ink-3)', fontSize: 15, fontFamily: 'inherit', cursor: 'pointer',
    }}>‹ Voltar</button>

    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', gap: 14, maxWidth: 420 }}>
      <div style={{ fontSize: 12, letterSpacing: '0.14em', textTransform: 'uppercase', color: 'var(--ember)' }}>
        Para Mentores
      </div>
      <h1 style={{ margin: 0, fontSize: 28, lineHeight: 1.15, fontWeight: 500 }}>
        Criar {term}s é para os Mentores do Forjamente
      </h1>
      <p style={{ margin: 0, fontSize: 15.5, lineHeight: 1.6, color: 'var(--ink-2)' }}>
        Você pode entrar e participar de qualquer {term}, à vontade e de graça.
        Encontre um que esteja lendo o que você gosta.
      </p>
      <button onClick={onExplore} style={{
        marginTop: 10, alignSelf: 'flex-start', padding: '13px 22px', borderRadius: 999,
        border: 'none', background: 'var(--ember)', color: 'var(--paper)',
        fontSize: 15, fontWeight: 600, fontFamily: 'inherit', cursor: 'pointer',
      }}>Explorar {term}s</button>
    </div>
  </div>
);

export default SoMentorScreen;
